<template>
  <div>
    <common-header title="Creator Management">
      <template #btn>
        <el-col style="width: 200px;">
          <el-button
            class="btn btn-default btn-outline-pink user_create_btn"
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.CREATOR,
              })
            "
          >
            <i class="fas fa-user-plus user_create_btn-i"></i>
            <span class="user_create_btn-text"> Create New Creator </span>
          </el-button>
        </el-col>
      </template>
    </common-header>
    <el-table :data="creatorList" border @row-click="toSubPage">
      <el-table-column prop="creator_id" label="id" sortable> </el-table-column>
      <el-table-column prop="name" label="Name" sortable> </el-table-column>
      <el-table-column prop="level" label="Level" sortable> </el-table-column>

      <el-table-column prop="timezone" label="Timezone" sortable>
      </el-table-column>
      <el-table-column
        prop="available_date"
        label="Available Date"
        sortable
        width="350px"
      >
        <template slot-scope="{ row }">
          <el-date-picker
            :value="row.available_date"
            type="daterange"
            range-separator="to"
            start-placeholder="start date"
            end-placeholder="end date"
            disabled
          >
          </el-date-picker>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="Status" sortable>
        <template slot-scope="{ row }">
          {{ row.status ? "active" : "offline" }}
        </template>
      </el-table-column>

      <el-table-column label="Operation">
        <template slot-scope="{ row }">
          <el-button
            class="btn btn-outline-pink"
            @click.stop.prevent="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.CREATOR,
                row: {
                  level: row.level,
                  creator_id: row.creator_id,
                  name: row.name,
                  status: row.status,
                  timezone: row.timezone,
                  available_date: row.available_date,
                },
              })
            "
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Edit"
              placement="bottom"
            >
              <i class="fas fa-pen"></i>
            </el-tooltip>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <dialogs></dialogs>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import CommonHeader from "@/components/base/header";
import Dialogs from "@/components/common/dialogs/index";

export default {
  data() {
    return {};
  },
  components: {
    CommonHeader,
    Dialogs,
  },
  created() {
    this.getAllCreator();
  },
  computed: {
    ...mapGetters({
      creatorList: "creatorManagement/creatorList",
    }),
  },
  methods: {
    ...mapActions({
      showContextMenu: "showContextMenu",
      showDialog: "showDialog",
      getAllCreator: "creatorManagement/getAllCreator",
    }),
    toSubPage(row) {
      console.log(row);
      this.$router.push(this.$route.path + `/${row.creator_id}`);
    },
  },
};
</script>
<style lang="sass" scoped>
.user
  &_create_btn
    width: 180px
    height: 32px
    border: 1px solid $color-pink
    border-radius: 3px
    padding: 9px 14px
    display: flex
    align-items: center
    &-i
      font-size: 12px
    &-text
      font-size: 12px
      margin-left: 8px
      font-weight: unset
      height: 14px
    span
      font-size: 12px !important
</style>
